
























































































































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Nav from "@/components/nav/navBar.vue";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
import BakcPress, { SUPER_PAY } from "@/utils/backPress";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { isIos } from "@/utils/lodash";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";
@Component({
  components: {
    Nav
  }
})
export default class BackUpAppToast extends Vue {
  //   @Prop({ default: "default value" })
  //   private propB?: string;
  @Getter(types.GETTER_BACK_UP_APP_DESC)
  private superPayDesc: any;
  @Getter(types.GETTER_BACK_UP_APP_LAUNCH_DESC)
  private superPayLaunchDesc: any;
  @Getter(types.GETTER_BACK_UP_APP_CONFIG)
  private superPayAppConfig: any;
  @Getter(types.GETTER_BACK_UP_APP_PARAMS)
  private superPayParams: any;
  @Action(types.START_INSTALL_BACK_UP_APP)
  private startInstallSuperPayApp: any;
  @Getter(types.GETTER_BACK_UP_APP_HAS_INSTALLED)
  private superPayAppHasInstalled: any;
  @Action(types.SHAKE_PLAY)
  private shakePlay: any;
  @Action(types.SHOW_FREE_FOLLOWERS)
  private showFreeFollowers: any;

  private superPayToastShow: boolean = false; //默认隐藏
  private superPayToastType: string = "dialog"; // dialog screen
  private closeFn: any = null;
  private gaType: string = "";
  // private shake: any;
  private shakeDelay: any;
  private shake_class: boolean = false;
  private listenKeyStr: any = "superPayToast";
  private hasShake: boolean = false;

  get showReward() {
    return (
      this.isLoginUser &&
      this.superPayParams.launch_reward_enabled &&
      !this.superPayAppHasInstalled
    );
  }

  get isIos() {
    return isIos();
  }

  get staticShowReward() {
    return this.isLoginUser && !this.superPayAppHasInstalled;
  }

  get isLoginUser() {
    return GeneralUtilsHelper.isLoginUser();
  }

  get superPayAppStarText() {
    return this.superPayAppConfig.appStar
      ? this.superPayAppConfig.appStar + ".0"
      : "5.0";
  }

  private clickClose() {
    this.superPayToastShow = false;
    this.clearState();
    BakcPress.destroy(SUPER_PAY);
    AppLifeCycle.removeListener(this.listenKeyStr);
    AppLifeCycle.removeGoBackListener(this.listenKeyStr);
  }

  private clickScrennClose() {
    this.superPayToastShow = false;
    this.clearState();
    if (this.closeFn) {
      this.closeFn();
    }
    if (this.superPayToastType !== "dialog") {
      setTimeout(() => {
        this.showFreeFollowers();
      }, 1000);
    }
  }

  private clickStart() {
    this.startInstallSuperPayApp({
      ga: this.gaType
    });
    this.clickScrennClose();
  }

  private clickStaticStart() {
    this.startInstallSuperPayApp({
      type: "static",
      ga: this.gaType
    });
    this.clickScrennClose();
  }

  private created() {
    //监听回调：
    EventBus.$on("show-back-up-toast", (val: any = { type: "dialog" }) => {
      console.log("how-super-pay-toast ON>>:", val);
      this.superPayToastType = val.type;
      this.superPayToastShow = true;

      if (val.hasOwnProperty("closeFn")) {
        this.closeFn = val.closeFn;
      } else {
        this.closeFn = null;
      }
      if (val.hasOwnProperty("ga")) {
        this.gaType = val.ga;
        sendEventWithParams("uia_recommend_app_show", {
          back_up: val.ga
        });
      }
      if (val.ga && val.ga === "pay_result_close") {
        console.log("BACK_UP_PAY_RESULT_CLOSE_SHOW_TIMES+1");
        SuperPayAndBackUpHelpers.addLocalKeyTimes(
          LOCAL_KEY.BACK_UP_PAY_RESULT_CLOSE_SHOW_TIMES
        );
      }
      BakcPress.listen({
        key: SUPER_PAY,
        fn: () => {
          this.clickClose();
        }
      });
      if (this.superPayToastType !== "dialog") {
        AppLifeCycle.addGoBackListener({
          key: this.listenKeyStr,
          fn: async () => {
            this.clearState();
          }
        });

        AppLifeCycle.addListener({
          key: this.listenKeyStr,
          fn: async () => {
            if (this.superPayToastShow) {
              this.clearState();
              this.initShakeState();
            }
          }
        });
        this.initShakeState();
      }
    });
  }

  private initShakeState() {
    this.$nextTick(() => {
      this.shakeDelay = setTimeout(() => {
        this.shake_class = true;
        if (this.hasShake) {
          return;
        }
        this.shakePlay({ android: 200, ios: 1 });
        this.hasShake = true;
        // this.shake = setInterval(() => this.shakePlay({android: 200, ios: 1, name: 'superPayToast'}), 4000)
      }, 1200);
    });
  }

  private clearState() {
    this.shake_class = false;
    // clearInterval(this.shake);
    clearTimeout(this.shakeDelay);
  }
}
